import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React, { useContext } from 'react';
import { Form } from 'semantic-ui-react';
import { validateFormField, getFieldError } from './CheckboxField.utils';
import { FormFieldCheckboxPropType } from '../../../../../types/FormField.types';
import { DynamicFormContext } from '../../../context/DynamicFormContext';
function CheckboxField(_ref) {
  var field = _ref.field,
    value = _ref.value;
  var _useContext = useContext(DynamicFormContext),
    isFormDisabled = _useContext.isFormDisabled,
    onChange = _useContext.onChange,
    formErrors = _useContext.formErrors,
    displayErrors = _useContext.displayErrors,
    clearFieldError = _useContext.clearFieldError,
    setFormErrors = _useContext.setFormErrors;
  var label = field.label,
    name = field.name,
    required = field.required;
  function handleChange(e, _ref2) {
    var fieldName = _ref2.name,
      fieldValue = _ref2.checked;
    clearFieldError(name);
    onChange(e, {
      name: fieldName,
      checked: fieldValue
    });
    var error = validateFormField(field, fieldValue);
    if (error) {
      setFormErrors(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), error);
      });
    }
  }
  return /*#__PURE__*/React.createElement(Form.Field, {
    disabled: isFormDisabled
  }, /*#__PURE__*/React.createElement(Form.Checkbox, {
    id: name,
    name: name,
    label: /*#__PURE__*/React.createElement("label", {
      htmlFor: name
    }, label),
    onChange: handleChange,
    checked: value,
    required: required,
    error: getFieldError(displayErrors, formErrors[name])
  }));
}
export default CheckboxField;